// CG_FLAG_ELASTIC_APM_IMPORT
/// //////////////////////////////////////////////////////////////////////////////////////
import { createRoot } from "react-dom/client";
import { AppBootstrapper, IAppMode, IAuthType } from "./bootstrapper";
import { IRouterType } from "./routes/router";
import { KuikaAppManager } from "./shared/utilty/kuika-app-manager";
import { KMainFunctions } from "./shared/utilty/main-functions";
import { ReactSystemFunctions } from "./shared/utilty/react-system-functions";
import WebComponentInit from "./web-component-init";
import { askPermission, registerServiceWorker } from "./services/notification-service";

KMainFunctions.ignoreKnownConsoleErrors();
KMainFunctions.ignoreKnownConsoleWarns();

// CG_FLAG_ELASTIC_APM_INIT

const owner = document.getElementById("emre-inanc-01-sistek");
if (owner) {
  const container = document.getElementById("emre-inanc-01-sistek");

  const root = createRoot(container!);

  const authType: IAuthType = "Kuika";
  const routerType: IRouterType = "BrowserRouter";
  const appMode: IAppMode = "WebSite";

  root.render(<AppBootstrapper authType={authType} routerType={routerType} appMode={appMode} />);

  if ((module as any).hot) {
    (module as any).hot.accept();
  }
} else {
  WebComponentInit();
}

registerServiceWorker();
askPermission();

navigator.serviceWorker.addEventListener("message", (event) => {
  if (event.data?.type === "notification-data") {
    const { screenId, parameters } = event.data.extraData;

    const path = getPathFromScreenId(screenId, parameters);

    window.location.href = path;
  }
});

function getPathFromScreenId(screenId: string | null, parameters: any): string {
  if (!screenId) return KuikaAppManager.GetFrontEndUrl();

  var screenName = ReactSystemFunctions.getScreenNameById(screenId);
  var path = `${KuikaAppManager.GetFrontEndUrl()}/${screenName}`;

  const { screenId: _, ...rest } = parameters;

  const query = new URLSearchParams(rest).toString();
  return query ? `${path}?${query}` : path;
}

const workspace = "emre_inanc_01";
const app = "sistek";
const webComponentTag = "emre-inanc-01-sistek";
export { app, webComponentTag, workspace };
